import cn from 'classnames'

import styles from './Spinner.module.scss'

type SpinnerProps = {
  size?: number
  className?: string
}

export const Spinner = ({ size = 16, className }: SpinnerProps) => (
  <span
    className={cn(styles.root, className)}
    style={{ width: size, height: size, borderWidth: Math.max(2, Math.round(size / 8)) }}
    aria-hidden
  />
)
